import type { EnumKind } from '@anytracker/core'

import { OptionListEditor, rescore } from './OptionListEditor.js'
import styles from './TrackEditor.module.css'

interface Props {
  readonly kind: EnumKind
  readonly onChange: (kind: EnumKind) => void
  /** Option ids that measurements already point at, so they cannot be deleted. */
  readonly recordedOptionIds: ReadonlySet<string>
  readonly newOptionId: () => string
}

/** One of a set: the option list, plus the question of whether it has an order. */
export function EnumKindEditor({
  kind,
  onChange,
  recordedOptionIds,
  newOptionId,
}: Props) {
  return (
    <>
      <div className={styles['toggle']}>
        <span className={styles['toggleText']}>
          <strong>These options have an order</strong>
          <span className={styles['toggleHint']}>
            {' '}
            An ordered list — <em>none, mild, strong</em> — can be averaged and charted as
            a line. An unordered one — <em>home, work, out</em> — can only ever be
            counted, because an average of it would be a number that looks meaningful and
            is not.
          </span>
        </span>
        <input
          type="checkbox"
          checked={kind.ordered}
          aria-label="These options have an order"
          onChange={(event) => {
            const ordered = event.target.checked
            onChange({
              ...kind,
              ordered,
              // Scores follow position by default. Someone turning this on has
              // already put the options in the order they mean.
              options: rescore(kind.options, ordered),
            })
          }}
        />
      </div>

      <OptionListEditor
        options={kind.options}
        scored={kind.ordered}
        recordedOptionIds={recordedOptionIds}
        newOptionId={newOptionId}
        onChange={(options) => onChange({ ...kind, options })}
      />
    </>
  )
}
